import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_AI3S_DEMO_END = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: "Find out more about Infosys\nResponsible AI from our staff.",
  bgImage: "RESPONSIBLE_AI/AI3S_d1_10.png",
  optionsButtons: [
    {
      label: "OVERVIEW",
      onClick: () => setCurrentPage(301),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage(306),
      endIcon: "arrow-right",
    },
  ],
};

export default DATA_AI3S_DEMO_END;
